"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var Logger = /** @class */ (function () {
    function Logger(config, moduleStack) {
        this.config = config;
        this.moduleStack = moduleStack || [];
    }
    Logger.prototype.setConfig = function (newConfig) {
        this.config = newConfig;
    };
    Logger.prototype.module = function (name) {
        var newStack = __spreadArray(__spreadArray([], this.moduleStack, true), [name], false);
        var newLogger = new Logger(this.config, newStack);
        return newLogger;
    };
    Logger.prototype.log = function (level, message, context) {
        var minimalLogLevel = this.config.minimalLogLevel || types_1.LogLevel.Trace;
        if (level < minimalLogLevel) {
            return;
        }
        var fullModule = this.moduleStack.join("::");
        var fullMessage = fullModule ? "".concat(fullModule, " ").concat(message) : message;
        this.config.loggerTransports.forEach(function (transport) {
            transport.log(level, fullMessage, context);
        });
    };
    Logger.prototype.trace = function (message, context) {
        this.log(types_1.LogLevel.Trace, message, context);
    };
    Logger.prototype.debug = function (message, context) {
        this.log(types_1.LogLevel.Debug, message, context);
    };
    Logger.prototype.info = function (message, context) {
        this.log(types_1.LogLevel.Info, message, context);
    };
    Logger.prototype.warn = function (message, context) {
        this.log(types_1.LogLevel.Warn, message, context);
        this.captureMessage("Warning log message: ".concat(message), context);
    };
    Logger.prototype.error = function (message, context) {
        this.log(types_1.LogLevel.Error, message, context);
        this.captureMessage("Error log message: ".concat(message), context);
    };
    Logger.prototype.fatal = function (message, context) {
        this.log(types_1.LogLevel.Fatal, message, context);
        this.captureMessage("Fatal log message: ".concat(message), context);
    };
    Logger.prototype.captureException = function (exception, context) {
        var logMessage = "Error: ".concat(exception.message);
        this.log(types_1.LogLevel.Error, logMessage, context);
        this.config.exceptionCapturers.forEach(function (capturer) {
            capturer.captureException(exception, context);
        });
    };
    Logger.prototype.captureMessage = function (message, context) {
        this.config.exceptionCapturers.forEach(function (capturer) {
            capturer.captureMessage(message, context);
        });
    };
    return Logger;
}());
exports.default = Logger;
